var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-list"},[(_vm.showImage)?_c('img',{staticClass:"m-r-8",attrs:{"src":require("@/assets/images/empty.png"),"width":"18px","height":"18px"}}):_vm._e(),_c('p',{staticClass:"message",domProps:{"innerHTML":_vm._s(_vm.message)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }